import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

export const InventoryAuditTable = (props) => {
  return (
    <table className="table table-striped table-bordered datatable mb-0">
      <thead>
        <tr>
          <th>Id</th>
          <th>Status</th>
          <th className="hidden-xs-down">Date Created</th>
          <th className="hidden-xs-down">Date Finished</th>
          <th className="hidden-xs-down">Created by</th>
          <th className="hidden-xs-down">Finished by</th>
          <th>Actions</th>
        </tr>
      </thead>
      <InventoryAuditList InventoryAudits={props.list}/>
    </table>
  )
};

export const EmptyTable = () => {
  return (
    <div className="shipment-list--empty">
      <div className="fa fa-list-ol icon" aria-hidden="true"></div>
      <div>No Inventory Audits yet</div>
    </div>
  )
};

const InventoryAuditTableRow = (props) => {
    let date_created = props.audit.date_created ? moment(props.audit.date_created).format('L') : '-';
    let date_finised = props.audit.date_finished ? moment(props.audit.date_finished).format('L') : '-';
    return(
      <tr>
        <td>{props.audit ? props.audit.id : ''}</td>
        <td>
          <span className={`badge badge-pill ${props.audit.status === 'In progress' ?
                'badge-warning': 'badge-success'}`}>{props.audit.status}</span>
        </td>
        <td className="hidden-xs-down">{date_created}</td>
        <td className="hidden-xs-down">{date_finised}</td>
        <td className="hidden-xs-down">{props.audit.created_by ? props.audit.created_by : '-'}</td>
        <td className="hidden-xs-down">{props.audit.finished_by ? props.audit.finished_by : '-'}</td>
        <td>
          <span>
            {props.audit.status === 'In progress' ?
              <NavLink to={`/inventory/audit/${props.audit.id}/edit`} className="btn-sm btn-info">
                <i className="fa fa-edit"></i>
              </NavLink>
              :
              <NavLink to={`/inventory/audit/${props.audit.id}`} className="btn-sm btn-info">
                <i className="fa fa-eye"></i>
              </NavLink>
            }
          </span>
        </td>
      </tr>
    )
};

export default class InventoryAuditList extends Component {
  render() {
    return (
      <tbody>
        {this.props.InventoryAudits.map((a,idx) => {
            return <InventoryAuditTableRow audit={a} key={idx}/>
          })
        }
      </tbody>
    );
  }
};
